import { getUserInfo } from '../../utils';

const ADMIN_ROLES = ['admin', 'super_admin'];

/**
 * Every attribution write (own entities, business units, assignments) is admin-only on
 * the server; this keeps the UI honest by hiding the controls for other roles.
 */
export const canManageAttribution = () => {
	const userInfo = getUserInfo();
	return Boolean(userInfo && ADMIN_ROLES.includes(userInfo.role));
};

/** Accepts a populated document, a plain id or null and returns the id string ('' when empty). */
export const asId = (value) => {
	if (!value) return '';
	if (typeof value === 'object') return String(value._id || value.id || '');
	return String(value);
};

/** "Gotasoft · Ernesto": a business unit's name prefixed by its own entity when it has one. */
export const unitLabel = (unit, entity) => {
	if (!unit) return '';
	const owner = entity === undefined ? unit.entity : entity;
	return owner?.name ? `${owner.name} · ${unit.name}` : unit.name;
};

/** Select option for a unit: "Gotasoft · Ernesto — socio Ernesto Quesada", "(inactiva)" when deactivated. */
export const unitOptionLabel = (unit) => {
	if (!unit) return '';
	const partner = unit.partner?.name ? ` — socio ${unit.partner.name}` : '';
	return `${unitLabel(unit)}${partner}${unit.active === false ? ' (inactiva)' : ''}`;
};
